// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header.header[data-v-1eb7f394]{color:#fff}header.header .header_wrapper[data-v-1eb7f394]{background-image:url(/frontimg/bg-main-top.jpg);background-position:center 60%;background-repeat:no-repeat;background-size:cover;padding-bottom:3.5rem;padding-top:0}@media(min-width:1260px){header.header .header_wrapper[data-v-1eb7f394]{padding-bottom:4.5rem;padding-top:3.5rem}}header.header .container[data-v-1eb7f394]{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
